import React from 'react';
import Button, { ButtonProps } from '@mui/material/Button';

interface CustomButtonProps extends ButtonProps {
    onClick?: () => void;
}

const CustomButton: React.FC<CustomButtonProps> = ({ onClick, children, ...rest }) => {
    return (
        <Button
            //variant="contained"
            startIcon={rest.startIcon}
            endIcon={rest.endIcon}
            onClick={onClick}
            color={rest.color}
            {...rest}
        >
            {children}
        </Button>
    );
};

export default CustomButton;
